var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 8 9", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6 1.3h1.6a.4.4 0 0 1 .4.4v6.4a.4.4 0 0 1-.4.4H.4a.4.4 0 0 1-.4-.4V1.7a.4.4 0 0 1 .4-.4H2V.5h.8v.8h2.4V.5H6v.8zm1.2 2.4V2.1H6v.8h-.8v-.8H2.8v.8H2v-.8H.8v1.6h6.4zm0 .8H.8v3.2h6.4V4.5zm-5.6.8h2v1.6h-2V5.3z" })
  );
});